import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import {
  checkAndLogin
} from '@/service/auth'


// create an axios instance
const service = axios.create({
  baseURL: '/', // api 的 base_url
  timeout: 5000, // request timeout
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded' // axios.defaults.headers.common
    'Content-Type': 'application/json' // 设置很关键
  },
})

// request interceptor
service.interceptors.request.use(
  config => {
    return checkAndLogin().then(res => {
      return config
    }).catch(err => {
      console.log(err)
    })
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // console.log(response)
    const res = response.data
    //超时统一处理
    // if (response.data.idsIntercepted && response.data.policy === "RESTRICTED") {
    //   MessageBox.confirm('登录超时', '确定登出', {
    //     confirmButtonText: '重新登录',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     location.reload() // 为了重新实例化vue-router对象 避免bug
    //   })
    //   return Promise.reject(res.msg || '系统繁忙, 请稍后重试')
    // } else {
    //   return res;
    // }
    if (response.status == 302) {
      checkAndLogin();
      return res;
    } else {
      return res;
    }
  },
  error => {
    console.log('axios error log', error)
    if (error.response == undefined) {
      Message({
        showClose: true,
        message: '接口异常，请刷新重试',
        type: 'error',
        duration: 2 * 1000
      })
      checkAndLogin();
    } else {
      Message({
        showClose: true,
        message: '接口异常，请刷新重试',
        type: 'error',
        duration: 2 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service